<template>
  <div class="t-dialogPage">
    <cmp-list v-if="!$route.query.sel || $route.query.sel === 'all' || !mobileState"></cmp-list>
    <cmp-message v-if="($route.query.sel && $route.query.sel !== 'all') || !mobileState"></cmp-message>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import List from './DialogList.vue'
    import Message from './MessageList.vue'

    export  default {
        components: {
            'cmp-list': List,
            'cmp-message': Message
        },
        computed: {
            ...mapGetters(['mobileState'])
        }
    }
</script>

<style lang="sass">
.t-dialogPage
  display: flex
  align-items: flex-start
  justify-content: flex-start
</style>


// WEBPACK FOOTER //
// src/vue_components/Dialog/Index.vue